import { render, staticRenderFns } from "./LinkDeviationTrainDeviationModal.vue?vue&type=template&id=22da6abe"
import script from "./LinkDeviationTrainDeviationModal.vue?vue&type=script&lang=js"
export * from "./LinkDeviationTrainDeviationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports